module.exports = __webpack_public_path__ + "4ee6752446ecfc58763158558538da69.pdf";